import React, { useState } from "react";
import PropTypes from "prop-types";
import { scrollIntoView } from "utils/helper";
import ContactDetailsInformation from "./contactDetailsInformation";
import EditContactDetailsInformation from "./editContactDetailsInformation";
import UseContactDetailsInformation from "./useContactDetailsInformation";

function Index({ isShowEditIcon }) {
  const [isEditMode, setIsEditMode] = useState(false);
  const { isContactDetailsLoading, onEditContactDetails } =
    UseContactDetailsInformation();

  const handleEditClick = () => {
    setIsEditMode(true);
  };

  const handleDiscard = () => {
    setIsEditMode(false);
    scrollIntoView("contactDetailsScrollId");
  };

  const handleSave = async (values) => {
    await onEditContactDetails(values);
    setIsEditMode(false);
  };

  if (isEditMode) {
    return (
      <EditContactDetailsInformation
        onDiscard={handleDiscard}
        onSave={handleSave}
        isLoading={isContactDetailsLoading}
      />
    );
  }

  return (
    <ContactDetailsInformation
      onEditClick={handleEditClick}
      isShowEditIcon={isShowEditIcon}
    />
  );
}

export default Index;
Index.propTypes = {
  isShowEditIcon: PropTypes.bool,
};
